import React, { useState } from 'react';
import { Typography, Button, Input, Space, Divider, Flex, theme, Grid } from 'antd';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';

const { useToken } = theme;
const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

// Tipos
interface WebsiteWidgetConfigProps {
  integrationCode: string;
  onCopy: () => void;
}

// Componente para el código de integración
const IntegrationCode: React.FC<{
  code: string;
  onCopy: () => void;
  isMobile: boolean;
  token: any;
}> = ({ code, onCopy, isMobile, token }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    onCopy();
    setIsCopied(true);
    // Reset the button text after 2 seconds
    setTimeout(() => {
      setIsCopied(false);
    }, 8000);
  };

  return (
  <Space.Compact
    style={{
      width: '100%',
      display: isMobile ? 'flex' : 'inline-flex',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: 'center',
      gap: token.marginXS,
    }}
  >
    <Flex style={{
      background: 'var(--ant-colorIconWidget)',
      borderRadius: '8px',
      width: '100%',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: '10px 0'
    }}>
      <Input
        readOnly
        value={code}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#ffffff',
          padding: '20px',
        }}
      />
      <Button
        icon={isCopied ? <CheckOutlined /> : <CopyOutlined />}
        onClick={handleCopy}
        style={{
          width: isMobile ? '100%' : 'auto',
          borderRadius: '8px',
          marginRight: '20px',
        }}
      >
        {isCopied ? 'Copied!' : 'Copy code'}
      </Button>
    </Flex>
  </Space.Compact>
  );
};

// Componente para la verificación de instalación
const InstallationVerification: React.FC<{ isMobile: boolean }> = ({ isMobile }) => (
  <Space.Compact
    style={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
{/*     <Title level={5} style={{ marginTop: '0.5rem' }}>Check installation</Title>
    <Paragraph type="secondary">
      Go to any page where the messenger is installed, and you'll see it appear in the bottom
      right corner. Alternatively, you can verify your installation below.
    </Paragraph>
    <Button style={{ width: isMobile ? '100%' : '180px', borderRadius: '8px' }}>
      Check installation
    </Button> */}
    <Title level={5} style={{ marginTop: '0.5rem' }}>Installation Steps:</Title>
    <ol>
      <li>Copy the code above</li>
      <li>Paste it just before the closing &lt;/body&gt; tag</li>
      <li>Save and publish your changes</li>
    </ol>
  </Space.Compact>
);

// Componente principal
export default function MyAssistantWebsiteWidgetConfig({
  integrationCode,
  onCopy,
}: WebsiteWidgetConfigProps) {
  const { token } = useToken();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <>
      <Divider style={{ padding: '0px', margin: '10px 0' }} />
      <Flex vertical gap={token.marginSM}>
        <Title level={5} style={{ marginTop: '0.5rem' }}>Website Widget</Title>
        <IntegrationCode 
          code={integrationCode} 
          onCopy={onCopy} 
          isMobile={isMobile} 
          token={token} 
        />
        <Divider style={{ padding: '0px', margin: '10px 0' }} />
        <InstallationVerification isMobile={isMobile} />
      </Flex>
    </>
  );
} 